import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=f18da640&"
import script from "./ProductFilter.vue?vue&type=script&lang=js&"
export * from "./ProductFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Container: require('/vercel/path0/components/general/Container.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default,FilterProductGridCard: require('/vercel/path0/components/cards/FilterProductGridCard.vue').default,FilterProductListCard: require('/vercel/path0/components/cards/FilterProductListCard.vue').default})
